export * from "./AttrSpecsSelectTable";
